import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { apiClient } from '@rti/shared'
import { initGoogleAnalytics } from './utils/googleAnalytics'

const prApiUrl = import.meta.env.VITE_API_BASE_URL
if (prApiUrl) {
  apiClient.setBaseUrl(prApiUrl)
}

initGoogleAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root')!);

const isDemo =
  window.location.pathname.startsWith('/demo/') || window.location.pathname === '/demo'

// Demo mode must be installed before React mounts. Imported dynamically so demo
// code stays out of the normal bundle.
async function start() {
  if (isDemo) {
    const { bootDemo } = await import('./demo/bootDemo')
    await bootDemo()
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

start();

